<template>
	<section class="layer-container" v-show="isShow">
		<div class="layer-box">
			<h3 class="layer-title box"><p class="box-flex">{{title}}</p><p><a @click="handleCancel" class="icon-close"></a></p></h3>
			<div class="layer-content">
				<slot></slot>
			</div>
			<h6 class="layer-btns  fx fx-y-center fx-x-right">
				<a v-show="isCancel" class="z-btn z-btn-default b-r-3 m-r-20" @click="handleCancel">{{cancelTitle}}</a>
				<a v-show="isOk" class="z-btn z-btn-primary b-r-3 m-r-20" @click="handleOk">{{okTitle}}</a>
			</h6>
		</div>
	</section>
</template>
<script>
	export default {
		name: "z-layers-material",
		data() {
			return {}
		},
		/*
		 * 接收父组件数据
		 */
		props: {
			isShow: {
				type: Boolean,
				default: false,
			},
			title: { //弹出层标题
				type: String,
				default: '',
			},
			isCancel: { //是否显示取消按钮
				type: Boolean,
				default: true,
			},
			isOk: { //是否显示确认按钮
				type: Boolean,
				default: true,
			},
			cancelTitle: {
				type: String,
				default: '取消',
			},
			okTitle: {
				type: String,
				default: '确定',
			}
		},
		methods: {
			handleOk() { //确定按钮
				this.$emit('handleOk')
			},
			handleCancel() { //取消按钮
				this.$emit('handleCancel')
			}
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.layer-container {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 998;
		background: rgba(0, 0, 0, 0.3);
		.layer-box {
			position: absolute;
			left: 10%;
			top: 10%;
			right: 10%;
			bottom: 10%;
			z-index: 9999;
			background: #fff;
			border: $color-border 1px solid;
			border-radius: 2px;
			.layer-title {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: px-em(112px);
				line-height: px-em(112px);
				font-size: 18px;
				padding: 0 px-em(40px);
				background: $color-lightgray;
				a {
					color: $color-font-sub;
					font-size: 24px;
				}
			}
			.layer-btns {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: px-em(88px);
				background: $color-lightgray;
			}
			.layer-content {
				position: absolute;
				top: px-em(112px);
				bottom: px-em(88px);
				left: 0;
				width: 100%;
				overflow-y: auto;
				border-top: $color-border 1px solid;
				border-bottom: $color-border 1px solid;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// LayersMaterial.vue?4659d3ae